import React, { Component } from 'react';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import Tooltip from 'tooltip.js';

const messages = localsMessages('common/ppcc');

export default class PPCC extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isToolTipOpen: false,
		}
	}
	
	componentDidMount = () => {
		this.createTooltip();
	}
	
	createTooltip() {
		const tooltipRef = document.getElementById('ppccIcon');
		let tooltip = new Tooltip(tooltipRef, {   // eslint-disable-line
			title: messages.ppcc.tooltip,
			trigger: TemplateData.ismobile ? 'click' : 'hover',
			placement: 'bottom',
			closeOnClickOutside: true
		})
	}
	
	render = () => {
		return (
			<span>
				<span
					className="ppvx_icon ppvx_icon--size_xs ppvx_icon-check-circle-alt ml-4 paypal-color"
					id="ppccIcon"
				></span>
			</span>
		)
	}
}
